export default __webpack_public_path__ + "static/media/rings_finale_3.86223e69.jpg";